export default function (context) {
  if (process.client) {
    context.store.dispatch('store__app__user/refreshSessionToken', context.req)
  }
}
